import React, { useState } from "react";
import classes from "./DeleteAccountPage.module.css";
import { InputText } from "primereact/inputtext";
import Spinner from "../Components/Loaders/Spinner";
import { toast } from "react-toastify";
import {
  useDeleteAccountMutation,
  useLoginMutation,
} from "../Slices/httpSlice";
import { useNavigate } from "react-router-dom";

const DeleteAccountPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const [deleteApi, { isLoading: deleteLoading }] = useDeleteAccountMutation();

  const loginHandler = async (e: any) => {
    e.preventDefault();
    if (email.trim().length == 0 && password.trim().length == 0) {
      toast.error("ထည့်သွင်းသည့်အကွက်များသည် ဗလာမဖြစ်နိုင်ပါ။");
      return;
    }
    try {
      const response: any = await deleteApi({ email, password });
      console.log(response, "r");
      console.log(response?.data?.result, "reult");
      console.log(response?.error?.status === 400, "error");
      if (response?.error?.status === 400) {
        console.log("enter here...");
        console.log(response?.error?.data?.error?.error, "e");
        toast.error(
          response?.error?.data?.error?.error ||
          response?.error?.data?.error ||
          response?.error?.data ||
          response?.error?.message ||
          "Something Went Wrong!"
        );
      } else {
        console.log("enter here...");
        toast.success("အကောင့်ကို အောင်မြင်စွာ ဖျက်လိုက်ပါပြီ။");
        navigate("/");
      }
    } catch (error: any) {
      console.log(error, "err");
      toast.error(error?.response?.data?.message);
    }
  };

  return (
    <div className={classes.auth_modal}>
      <div className={classes.auth_sub_modal}>
        <div className={classes.form_modal}>
          <p className={classes.title}>အကောင့်ဖျက်ပါ။</p>

          <form className={classes.form} onSubmit={loginHandler}>
            <InputText
              type="text"
              className={`p-inputtext-lg ${classes.input}`}
              placeholder="အသုံးပြုသူအမည် သို့မဟုတ် example@gmail.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <InputText
              type="password"
              className={`p-inputtext-lg ${classes.input}`}
              placeholder="စကားဝှက်"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <button
              type="submit"
              disabled={deleteLoading}
              className={classes.signup_btn}
            >
              {deleteLoading ? (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Spinner />
                </div>
              ) : (
                "အကောင့်ဖျက်ပါ။"
              )}
            </button>
          </form>
        </div>
        <div className={classes.benefits_modal}>
          <p className={classes.benefits_title}>
            သင့်အကောင့်ကို ဖျက်လိုသည်မှာ သေချာပါသလား။
          </p>

          <div className={classes.benefits}>
            <div className={classes.benefit}>
              <div className={classes.benefit_title}>
                <i className={`pi pi-circle-fill ${classes.icon}`} />
                <p className={classes.bt}>
                  မင်းသွားတွေ့တာ စိတ်မကောင်းပါဘူး။ သင့်အကောင့်ကို ဖျက်လိုက်တာက ရလဒ်ထွက်လာပါလိမ့်မယ်။
                  အောက်ပါတို့တွင်
                </p>
              </div>
              <p className={classes.bd}>
                သင်၏ကြည့်ရှုစာရင်းနှင့် သုံးသပ်ချက်များ ထာဝရဆုံးရှုံးခြင်း။
              </p>
              <p className={classes.bd}>
                ကွန်မြူနတီကဏ္ဍရှိ သင့်ပို့စ်များကို ဖယ်ရှားခြင်း။
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteAccountPage;
